/** IBAN in groups of four for display, e.g. `SE72 8000 0810 3400 0978 3242` */
export const formatIban = (iban: string): string =>
  iban
    .replace(/\s+/g, '')
    .replace(/(.{4})/g, '$1 ')
    .trim()
